module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('SectionLabel', {
    attrs: {
      "label": _vm.trads.label
    }
  }), _vm._v(" "), (_vm.loading) ? _c('Loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": "default-campaign"
    }
  }, [_c('label', {
    attrs: {
      "required": ""
    }
  }, [_vm._v(_vm._s(_vm.trads.defaultLaunchAndDiscontinuation))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.startCampaignId),
      expression: "value.startCampaignId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.value.startCampaignId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("–––")]), _vm._v(" "), _vm._l((_vm.campaigns), function(campaign) {
    return _c('option', {
      key: campaign.id,
      attrs: {
        "disabled": !_vm.isValidCampaignRange({
          startId: campaign.id,
          endId: _vm.value.endCampaignId
        })
      },
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v(_vm._s(campaign.name))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.endCampaignId),
      expression: "value.endCampaignId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.value.endCampaignId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v(_vm._s(_vm.trads.onGoing))]), _vm._v(" "), _vm._l((_vm.campaigns), function(campaign) {
    return _c('option', {
      key: campaign.id,
      attrs: {
        "disabled": !_vm.isValidCampaignRange({
          startId: _vm.value.startCampaignId,
          endId: campaign.id,
          allowEquals: false
        })
      },
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v(_vm._s(campaign.name))])
  })], 2)]), _vm._v(" "), _c('section', [_c('label', {
    attrs: {
      "required": ""
    }
  }, [_vm._v(_vm._s(_vm.trads.zonesAndMarkets))]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "zones"
    }
  }, [_vm._l((_vm.zones), function(zone) {
    return (!_vm.isDisabledZone(zone.id)) ? _c('li', {
      key: zone.key,
      class: {
        checked: _vm.value.zoneDetailsPerId[zone.id] && _vm.value.zoneDetailsPerId[zone.id].checked
      }
    }, [_c('span', [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": ("zone-" + (zone.id))
      },
      domProps: {
        "checked": _vm.value.zoneDetailsPerId[zone.id] && _vm.value.zoneDetailsPerId[zone.id].checked
      },
      on: {
        "input": function (e) { return _vm.setZone(zone.id, {
          checked: e.target.checked
        }); }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "d-inline",
      attrs: {
        "for": ("zone-" + (zone.id))
      }
    }, [_vm._v(_vm._s(zone.name))])]), _vm._v(" "), _c('select', {
      attrs: {
        "disabled": !_vm.value.zoneDetailsPerId[zone.id] || !_vm.value.zoneDetailsPerId[zone.id].checked
      },
      domProps: {
        "value": _vm.zoneStartId(zone.id)
      },
      on: {
        "input": function (e) { return _vm.setZone(zone.id, {
          startCampaignId: Number.parseInt(e.target.value)
        }); }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("–––")]), _vm._v(" "), _vm._l((_vm.campaigns), function(campaign) {
      return _c('option', {
        key: campaign.id,
        attrs: {
          "disabled": !_vm.isValidCampaignRange({
            startId: campaign.id,
            endId: _vm.zoneEndId(zone.id)
          })
        },
        domProps: {
          "value": campaign.id
        }
      }, [_vm._v("\n                        " + _vm._s(campaign.name) + "\n                    ")])
    })], 2), _vm._v(" "), _c('select', {
      attrs: {
        "disabled": !_vm.value.zoneDetailsPerId[zone.id] || !_vm.value.zoneDetailsPerId[zone.id].checked
      },
      domProps: {
        "value": _vm.zoneEndId(zone.id)
      },
      on: {
        "input": function (e) { return _vm.setZone(zone.id, {
          endCampaignId: (e.target.value && Number.parseInt(e.target.value, 10)) || undefined
        }); }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v(_vm._s(_vm.trads.onGoing))]), _vm._v(" "), _vm._l((_vm.campaigns), function(campaign) {
      return _c('option', {
        key: campaign.id,
        attrs: {
          "disabled": !_vm.isValidCampaignRange({
            startId: _vm.zoneStartId(zone.id),
            endId: campaign.id,
            allowEquals: false
          })
        },
        domProps: {
          "value": campaign.id
        }
      }, [_vm._v(_vm._s(campaign.name))])
    })], 2)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.zones), function(zone) {
    return (_vm.isDisabledZone(zone.id)) ? _c('li', {
      key: zone.key
    }, [_c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(zone.name) + " "), _c('i', [_vm._v("(DELETED)")])])]) : _vm._e()
  })], 2), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.trads.description))]), _vm._v(" "), _c('TranslationInput', {
    attrs: {
      "id": "description",
      "area": true
    },
    model: {
      value: (_vm.value.description),
      callback: function($$v) {
        _vm.value.description = $$v
      },
      expression: "value.description"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.trads.status))]), _vm._v(" "), _c('RadioGroup', {
    attrs: {
      "id": "status",
      "name": "status",
      "options": _vm.statusOptions
    },
    model: {
      value: (_vm.value.statusId),
      callback: function($$v) {
        _vm.value.statusId = $$v
      },
      expression: "value.statusId"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "required": ""
    }
  }, [_vm._v(_vm._s(_vm.trads.categories))]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "categories"
    }
  }, [_c('ul', _vm._l((_vm.selectedCategories), function(pair, i) {
    return _c('li', {
      key: i
    }, [_vm._l((pair), function(item, index) {
      return _c('select', {
        key: _vm.forceRefreshCategoriesPicker,
        domProps: {
          "value": pair[index]
        },
        on: {
          "input": function($event) {
            _vm.updateCategory(i, index, $event.target.value);
          }
        }
      }, [_c('option', {
        domProps: {
          "value": undefined
        }
      }, [_vm._v("–––")]), _vm._v(" "), _vm._l((_vm.findListCategories(item, pair)), function(category) {
        return _c('option', {
          key: category.id,
          domProps: {
            "value": category.id
          }
        }, [_vm._v(_vm._s(category.terms.name[_vm.$locale]))])
      })], 2)
    }), _vm._v(" "), (_vm.findListCategories(null, pair).length) ? _c('select', {
      key: _vm.forceRefreshCategoriesPicker,
      domProps: {
        "value": undefined
      },
      on: {
        "input": function($event) {
          _vm.updateCategory(i, pair.length, $event.target.value);
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("–––")]), _vm._v(" "), _vm._l((_vm.findListCategories(null, pair)), function(category) {
      return _c('option', {
        key: category.id,
        domProps: {
          "value": category.id
        }
      }, [_vm._v(_vm._s(category.terms.name[_vm.$locale]))])
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.removeCategory(pair);
        }
      }
    }, [_vm._v("x")])], 2)
  })), _vm._v(" "), _c('button', {
    attrs: {
      "id": "add-category"
    },
    on: {
      "click": _vm.addCategory
    }
  }, [_vm._v(_vm._s(_vm.trads.addCategory))])])], 1), _vm._v(" "), (_vm.zones.length > 0) ? _c('FormEstore', {
    attrs: {
      "zones": _vm.zones,
      "brandZones": _vm.brandZones,
      "zonesChecked": _vm.value.zoneDetailsPerId
    },
    model: {
      value: (_vm.value.eStoreData),
      callback: function($$v) {
        _vm.value.eStoreData = $$v
      },
      expression: "value.eStoreData"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07e75e74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-form/form-default-campaign.vue
// module id = 2995
// module chunks = 0